import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/acq/AdvertiseMiniLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/acq/EmptySlotHouseAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/paid/PaidAdCarouselClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/paid/PaidAdClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ads/promo/PromoDistrictSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/apt/detail/carousel/CarouselNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds/v3/region-rd2.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/apt/sub/apt-sub.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds2/CardImg.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/home-r1.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds2/ds2.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/carousel/home-carousel.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ads/paid/paid-ads.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/home-v3.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/home-cl.css");
;
import(/* webpackMode: "eager", webpackExports: ["HomeUpcomingMore","HomeRegionSlot","HomeUpcomingGrid","HomeRegionBar"] */ "/vercel/path0/src/components/home/HomeRegionFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeScopeEyebrow","HomeRegionHero"] */ "/vercel/path0/src/components/home/HomeRegionScope.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/HomeRegionTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/HomeTodayImminent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegionParamRobots"] */ "/vercel/path0/src/components/nav/RegionFilterSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/search/HomeHeroChips.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/search/KdSearchBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/search/PopularRegionSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/thumb/Thumb.tsx");
